import * as s from './styles/header.module.css';
import type { IHeader } from './types';

const Header = ({ children, ...props }: IHeader) => {
  if (!children) return null;

  return (
    <div className={s.styledHeader} {...props}>
      <div className="grid">
        {children}
      </div>
    </div>
  );
};

export default Header;
